import { HookAction, WorkflowZoneConfig } from '@finxone-platform/shared/sys-config-types';
import { generateOnboardingDefaultPage } from '../pages/onboarding.pages';
import { thirdPartyKycPageConfig } from '../pages/verification.pages';

// hook function looked up at runtime as can't be stored in config
export const zoneHooks: {
  [key: string]: (
    zoneConfig: WorkflowZoneConfig,
    action: HookAction,
    currentPageIndex: number,
  ) => WorkflowZoneConfig;
} = {
  //   'card-management-hook': cardManagementZoneHook,
  'signup-page-hook': signupWidgetHook,
  'verification-third-party-kyc-hook': (
    zoneConfig,
    action,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    currentPageIndex,
  ) => {
    const pages = [thirdPartyKycPageConfig];
    // Will add or remove pages in zone
    pages.forEach((page) => {
      const zoneHookPageIndex = zoneConfig.pages.findIndex((zonePage) => zonePage.name === page.name);
      if (action === 'add') {
        if (zoneHookPageIndex == -1) zoneConfig.pages.push(page);
      }
    });
    return zoneConfig;
  },
};

function signupWidgetHook(
  zoneConfig: WorkflowZoneConfig,
  action: HookAction,
  currentPageIndex: number,
): WorkflowZoneConfig {
  if (action === 'add') {
    // On add then update profile page with correct url etc
    const onboardingPageConfig = generateOnboardingDefaultPage();
    zoneConfig.pages[currentPageIndex] = {
      ...zoneConfig.pages[currentPageIndex],
      name: onboardingPageConfig.name,
      pageConfiguration: onboardingPageConfig.pageConfiguration,
      title: onboardingPageConfig.title,
    };
  }

  return zoneConfig;
}
